import { compose, createStore, applyMiddleware } from 'redux';
import { devTools } from 'redux-devtools';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import rootReducer from 'reducers';

let createStoreWithMiddleware;

const logger = createLogger({
  level: 'info',
  collapsed: true
  // predicate: (getState, action) => action.type !== AUTH_REMOVE_TOKEN
});

const middleware = [
  thunk,
  logger
];

if (__DEBUG__) {
  createStoreWithMiddleware = compose(
    applyMiddleware(...middleware),
    devTools()
  )(createStore);
} else {
  createStoreWithMiddleware = applyMiddleware(...middleware)(createStore);
}

export default function configureStore (initialState) {
  const store = createStoreWithMiddleware(rootReducer, initialState);

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers/index');

      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/store.js